export enum BorderStyle {
    All = "all",
    None = "none",
    Horizontal = "center-h",
    Vertical = "center-v",
    Outside = "outer",
}

export enum BorderThickness {
    // if you change anything here then make sure to add the same in the db changes
    // for example light-solid is used in the db
    LightSolid = "light-solid",
    BoldSolid = "bold-solid",
}

export enum TabBackground {
    // if you change anything here then make sure to add the same in the db changes
    // for example duoChrome is used in the db
    DuoChrome = "duoChrome",
    MonoChrome = "monoChrome",
}

export enum DefaultColorsKeys {
    PrimaryColor = "PrimaryColor",
    SecondaryColor = "SecondaryColor",
    ErrorColor = "ErrorColor",
    NeutralDarkColor = "NeutralDarkColor",
    NeutralLightColor = "NeutralLightColor",
    BlackColor = "BlackColor",
    WhiteColor = "WhiteColor",
    NoColor = "NoColor",
}

export interface DynamicCssModel {
    HasGridChanges: boolean;

    LightSolidBorder: BorderThickness;
    BoldSolidBorder: BorderThickness;

    TableRowDefaultTabBackground: TabBackground;
    TableRowActiveTab: "tab-default";
    TableRowDefaultTabFillPrimaryColor: DefaultColorsKeys;
    TableRowDefaultTabFillPrimaryColorPercent: string;
    TableRowDefaultTabFillSecondaryColor: DefaultColorsKeys;
    TableRowDefaultTabFillSecondaryColorPercent: string;
    TableRowBorderStyle: BorderStyle;
    TableRowBorderThickness: BorderThickness;
    TableRowBorderColor: DefaultColorsKeys;
    TableRowBorderColorPercent: string;

    TableRowHoverTabColor: DefaultColorsKeys;
    TableRowHoverTabColorPercent: string;

    TableRowSelectedTabColor: DefaultColorsKeys;
    TableRowSelectedTabColorPercent: string;

    TableHeaderBorderStyle: BorderStyle;
    TableHeaderBorderThickness: BorderThickness;
    TableHeaderBorderColor: DefaultColorsKeys;
    TableHeaderBorderColorPercent: string;
    TableHeaderFillColor: string;
    TableHeaderFillColorPercent: string;
}
